import { render, staticRenderFns } from "./FontFamilies.vue?vue&type=template&id=73a181b3&"
import script from "./FontFamilies.vue?vue&type=script&lang=js&"
export * from "./FontFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports